export enum AIModelClz {
	AIModel = 'com.infa.ccgf.models.AIModel.AIModel',
}

export enum AtlasClz {
	AtlasServer = 'com.infa.odin.models.Atlas.AtlasServer',
	Calculation = 'com.infa.odin.models.Atlas.Calculation',
	HiveProcess = 'com.infa.odin.models.Atlas.HiveProcess',
	SqoopProcess = 'com.infa.odin.models.Atlas.SqoopProcess',
}

export enum AzureDataFactoryClz {
	Activity = 'com.infa.odin.models.AzureDataFactory.Activity',
	Calculation = 'com.infa.odin.models.AzureDataFactory.Calculation',
	Dataflow = 'com.infa.odin.models.AzureDataFactory.Dataflow',
	Dataset = 'com.infa.odin.models.AzureDataFactory.Dataset',
	Factory = 'com.infa.odin.models.AzureDataFactory.Factory',
	Folder = 'com.infa.odin.models.AzureDataFactory.Folder',
	Pipeline = 'com.infa.odin.models.AzureDataFactory.Pipeline',
	PipelineInstance = 'com.infa.odin.models.AzureDataFactory.PipelineInstance',
}

export enum BIClz {
	Report = 'com.infa.odin.models.BI.Report',
	ReportCluster = 'com.infa.odin.models.BI.ReportCluster',
	ReportElement = 'com.infa.odin.models.BI.ReportElement',
}

export enum CDMPCollaborationClz {
	Channel = 'com.infa.ccgf.models.cdmp.collaboration.Channel',
	InteractionChannel = 'com.infa.ccgf.models.cdmp.collaboration.InteractionChannel',
	RatingChannel = 'com.infa.ccgf.models.cdmp.collaboration.RatingChannel',
	Target = 'com.infa.ccgf.models.cdmp.collaboration.Target',
}

export enum CognosClz {
	ActiveReport = 'com.infa.odin.models.cognos.ActiveReport',
	ActiveReportVariable = 'com.infa.odin.models.cognos.ActiveReportVariable',
	Argument = 'com.infa.odin.models.cognos.Argument',
	Attribute = 'com.infa.odin.models.cognos.Attribute',
	BooleanVariable = 'com.infa.odin.models.cognos.BooleanVariable',
	CalculatedMeasure = 'com.infa.odin.models.cognos.CalculatedMeasure',
	CalculatedMember = 'com.infa.odin.models.cognos.CalculatedMember',
	Calculation = 'com.infa.odin.models.cognos.Calculation',
	CalculationShortcut = 'com.infa.odin.models.cognos.CalculationShortcut',
	ChartNodeMember = 'com.infa.odin.models.cognos.ChartNodeMember',
	Column = 'com.infa.odin.models.cognos.Column',
	ConditionFilter = 'com.infa.odin.models.cognos.ConditionFilter',
	Connection = 'com.infa.odin.models.cognos.Connection',
	ConnectionPackageDataSource = 'com.infa.odin.models.cognos.ConnectionPackageDataSource',
	CrosstabNodeMember = 'com.infa.odin.models.cognos.CrosstabNodeMember',
	Dashboard = 'com.infa.odin.models.cognos.Dashboard',
	DashboardModel = 'com.infa.odin.models.cognos.DashboardModel',
	DataAttribute = 'com.infa.odin.models.cognos.DataAttribute',
	DataAttributeMeasure = 'com.infa.odin.models.cognos.DataAttributeMeasure',
	DataModule = 'com.infa.odin.models.cognos.DataModule',
	DataModuleModel = 'com.infa.odin.models.cognos.DataModuleModel',
	DataSet = 'com.infa.odin.models.cognos.DataSet',
	DataSetModel = 'com.infa.odin.models.cognos.DataSetModel',
	DataSource = 'com.infa.odin.models.cognos.DataSource',
	DataSourceSchema = 'com.infa.odin.models.cognos.DataSourceSchema',
	DatabaseConnection = 'com.infa.odin.models.cognos.DatabaseConnection',
	DatabaseQuery = 'com.infa.odin.models.cognos.DatabaseQuery',
	DatabaseQueryShortcut = 'com.infa.odin.models.cognos.DatabaseQueryShortcut',
	DatabaseSchema = 'com.infa.odin.models.cognos.DatabaseSchema',
	DelimitedColumn = 'com.infa.odin.models.cognos.DelimitedColumn',
	DelimitedFile = 'com.infa.odin.models.cognos.DelimitedFile',
	Dimension = 'com.infa.odin.models.cognos.Dimension',
	DimensionAttribute = 'com.infa.odin.models.cognos.DimensionAttribute',
	DimensionAttributeCalculation = 'com.infa.odin.models.cognos.DimensionAttributeCalculation',
	DimensionMap = 'com.infa.odin.models.cognos.DimensionMap',
	DimensionShortcut = 'com.infa.odin.models.cognos.DimensionShortcut',
	Directory = 'com.infa.odin.models.cognos.Directory',
	DynamicCube = 'com.infa.odin.models.cognos.DynamicCube',
	DynamicSource = 'com.infa.odin.models.cognos.DynamicSource',
	Field = 'com.infa.odin.models.cognos.Field',
	FieldBody = 'com.infa.odin.models.cognos.FieldBody',
	File = 'com.infa.odin.models.cognos.File',
	Filter = 'com.infa.odin.models.cognos.Filter',
	FilterShortcut = 'com.infa.odin.models.cognos.FilterShortcut',
	FixedWidthColumn = 'com.infa.odin.models.cognos.FixedWidthColumn',
	FixedWidthFile = 'com.infa.odin.models.cognos.FixedWidthFile',
	Folder = 'com.infa.odin.models.cognos.Folder',
	FrameworkManagerModel = 'com.infa.odin.models.cognos.FrameworkManagerModel',
	Function = 'com.infa.odin.models.cognos.Function',
	Hierarchy = 'com.infa.odin.models.cognos.Hierarchy',
	Identifier = 'com.infa.odin.models.cognos.Identifier',
	KeyLevelAttribute = 'com.infa.odin.models.cognos.KeyLevelAttribute',
	LanguageVariable = 'com.infa.odin.models.cognos.LanguageVariable',
	Level = 'com.infa.odin.models.cognos.Level',
	LevelAttribute = 'com.infa.odin.models.cognos.LevelAttribute',
	Macro = 'com.infa.odin.models.cognos.Macro',
	Measure = 'com.infa.odin.models.cognos.Measure',
	MeasureDimension = 'com.infa.odin.models.cognos.MeasureDimension',
	MeasureDimensionShortcut = 'com.infa.odin.models.cognos.MeasureDimensionShortcut',
	Member = 'com.infa.odin.models.cognos.Member',
	Model = 'com.infa.odin.models.cognos.Model',
	ModelConnection = 'com.infa.odin.models.cognos.ModelConnection',
	ModelQuery = 'com.infa.odin.models.cognos.ModelQuery',
	ModelQueryShortcut = 'com.infa.odin.models.cognos.ModelQueryShortcut',
	Namespace = 'com.infa.odin.models.cognos.Namespace',
	OlapSchemaNamespace = 'com.infa.odin.models.cognos.OlapSchemaNamespace',
	Package = 'com.infa.odin.models.cognos.Package',
	Parameter = 'com.infa.odin.models.cognos.Parameter',
	ProcedureQuery = 'com.infa.odin.models.cognos.ProcedureQuery',
	Prompt = 'com.infa.odin.models.cognos.Prompt',
	PromptAnswer = 'com.infa.odin.models.cognos.PromptAnswer',
	Query = 'com.infa.odin.models.cognos.Query',
	QueryItem = 'com.infa.odin.models.cognos.QueryItem',
	QueryPackage = 'com.infa.odin.models.cognos.QueryPackage',
	QueryStudioModel = 'com.infa.odin.models.cognos.QueryStudioModel',
	QuerySubject = 'com.infa.odin.models.cognos.QuerySubject',
	Relationship = 'com.infa.odin.models.cognos.Relationship',
	Report = 'com.infa.odin.models.cognos.Report',
	ReportFieldMeasure = 'com.infa.odin.models.cognos.ReportFieldMeasure',
	ReportFilter = 'com.infa.odin.models.cognos.ReportFilter',
	ReportFilterCondition = 'com.infa.odin.models.cognos.ReportFilterCondition',
	ReportStudioModel = 'com.infa.odin.models.cognos.ReportStudioModel',
	Repository = 'com.infa.odin.models.cognos.Repository',
	ResultColumn = 'com.infa.odin.models.cognos.ResultColumn',
	ResultSet = 'com.infa.odin.models.cognos.ResultSet',
	Schema = 'com.infa.odin.models.cognos.Schema',
	ScopeRelationship = 'com.infa.odin.models.cognos.ScopeRelationship',
	StoredProcedure = 'com.infa.odin.models.cognos.StoredProcedure',
	StringVariable = 'com.infa.odin.models.cognos.StringVariable',
	SummaryStoreConnection = 'com.infa.odin.models.cognos.SummaryStoreConnection',
	Table = 'com.infa.odin.models.cognos.Table',
	Text = 'com.infa.odin.models.cognos.Text',
	TimeDimension = 'com.infa.odin.models.cognos.TimeDimension',
	Transformer = 'com.infa.odin.models.cognos.Transformer',
	TransformerModel = 'com.infa.odin.models.cognos.TransformerModel',
	UserAccount = 'com.infa.odin.models.cognos.UserAccount',
	View = 'com.infa.odin.models.cognos.View',
	ViewColumn = 'com.infa.odin.models.cognos.ViewColumn',
}

export enum CoreClz {
	Calculation = 'core.Calculation',
	Classification = 'core.Classification',
	Cluster = 'core.Cluster',
	Container = 'core.Container',
	DataClassification = 'core.DataClassification',
	DataElement = 'core.DataElement',
	DataElementClassification = 'core.DataElementClassification',
	DataElementProfile = 'core.DataElementProfile',
	DataEntityClassification = 'core.DataEntityClassification',
	DataProcess = 'core.DataProcess',
	DataProcessCluster = 'core.DataProcessCluster',
	DataSet = 'core.DataSet',
	DataSetCluster = 'core.DataSetCluster',
	DataSetExtension = 'core.DataSetExtension',
	DataSource = 'core.DataSource',
	IClass = 'core.IClass',
	IClassBusiness = 'core.IClassBusiness',
	IClassExtension = 'core.IClassExtension',
	IClassSystem = 'core.IClassSystem',
	IClassTechnical = 'core.IClassTechnical',
	InferredDataTypeSummary = 'core.InferredDataTypeSummary',
	LookupTable = 'core.LookupTable',
	MergeFact = 'core.MergeFact',
	ObjectReference = 'core.ObjectReference',
	PatternFrequency = 'core.PatternFrequency',
	RankedValue = 'core.RankedValue',
	Resource = 'core.Resource',
	Stakeholder = 'core.Stakeholder',
	User = 'core.User',
	UserGroup = 'core.UserGroup',
	ValueFrequency = 'core.ValueFrequency',
}

export enum DashboardClz {
	BaseWidget = 'com.infa.application.dashboard.BaseWidget',
	ClaireActivityWidget = 'com.infa.application.dashboard.ClaireActivityWidget',
	Dashboard = 'com.infa.application.dashboard.Dashboard',
	DataQualityWidget = 'com.infa.application.dashboard.DataQualityWidget',
	HelpWidget = 'com.infa.application.dashboard.HelpWidget',
	JobsWidget = 'com.infa.application.dashboard.JobsWidget',
	NoticeBoardWidget = 'com.infa.application.dashboard.NoticeBoardWidget',
	SearchWidget = 'com.infa.application.dashboard.SearchWidget',
	TicketsWidget = 'com.infa.application.dashboard.TicketsWidget',
}

export enum DataSerializedClz {
	DataStructure = 'com.infa.odin.models.data.serialized.DataStructure',
	DataStructureField = 'com.infa.odin.models.data.serialized.DataStructureField',
}

export enum DatabricksClz {
	Calculation = 'com.infa.odin.models.Databricks.Calculation',
	Command = 'com.infa.odin.models.Databricks.Command',
	Folder = 'com.infa.odin.models.Databricks.Folder',
	Notebook = 'com.infa.odin.models.Databricks.Notebook',
	NotebookDefinition = 'com.infa.odin.models.Databricks.NotebookDefinition',
	NotebookInstance = 'com.infa.odin.models.Databricks.NotebookInstance',
	Parameter = 'com.infa.odin.models.Databricks.Parameter',
	Result = 'com.infa.odin.models.Databricks.Result',
}

export enum ErstudioClz {
	Attachment = 'com.infa.odin.models.erstudio.Attachment',
	AttachmentType = 'com.infa.odin.models.erstudio.AttachmentType',
	Attribute = 'com.infa.odin.models.erstudio.Attribute',
	CandidateKey = 'com.infa.odin.models.erstudio.CandidateKey',
	Column = 'com.infa.odin.models.erstudio.Column',
	Condition = 'com.infa.odin.models.erstudio.Condition',
	Default = 'com.infa.odin.models.erstudio.Default',
	Diagram = 'com.infa.odin.models.erstudio.Diagram',
	Domain = 'com.infa.odin.models.erstudio.Domain',
	Entity = 'com.infa.odin.models.erstudio.Entity',
	FileDirectory = 'com.infa.odin.models.erstudio.FileDirectory',
	FlatFileModel = 'com.infa.odin.models.erstudio.FlatFileModel',
	FlatFileSource = 'com.infa.odin.models.erstudio.FlatFileSource',
	Folder = 'com.infa.odin.models.erstudio.Folder',
	ForeignKey = 'com.infa.odin.models.erstudio.ForeignKey',
	IdentifyingRelationship = 'com.infa.odin.models.erstudio.IdentifyingRelationship',
	Identity = 'com.infa.odin.models.erstudio.Identity',
	Index = 'com.infa.odin.models.erstudio.Index',
	IndexMember = 'com.infa.odin.models.erstudio.IndexMember',
	LogicalDataModel = 'com.infa.odin.models.erstudio.LogicalDataModel',
	LogicalModel = 'com.infa.odin.models.erstudio.LogicalModel',
	LogicalSource = 'com.infa.odin.models.erstudio.LogicalSource',
	LogicalSubmodel = 'com.infa.odin.models.erstudio.LogicalSubmodel',
	LogicalSubmodelDiagram = 'com.infa.odin.models.erstudio.LogicalSubmodelDiagram',
	MainLogicalModel = 'com.infa.odin.models.erstudio.MainLogicalModel',
	MainPhysicalModel = 'com.infa.odin.models.erstudio.MainPhysicalModel',
	NamedRelationshipEnd = 'com.infa.odin.models.erstudio.NamedRelationshipEnd',
	NonIdentifyingRelationship = 'com.infa.odin.models.erstudio.NonIdentifyingRelationship',
	NonSpecificRelationship = 'com.infa.odin.models.erstudio.NonSpecificRelationship',
	Note = 'com.infa.odin.models.erstudio.Note',
	OtherSource = 'com.infa.odin.models.erstudio.OtherSource',
	Parameter = 'com.infa.odin.models.erstudio.Parameter',
	PhysicalDataModel = 'com.infa.odin.models.erstudio.PhysicalDataModel',
	PhysicalModel = 'com.infa.odin.models.erstudio.PhysicalModel',
	PhysicalSource = 'com.infa.odin.models.erstudio.PhysicalSource',
	PhysicalSubmodel = 'com.infa.odin.models.erstudio.PhysicalSubmodel',
	PhysicalSubmodelDiagram = 'com.infa.odin.models.erstudio.PhysicalSubmodelDiagram',
	PrimaryKey = 'com.infa.odin.models.erstudio.PrimaryKey',
	PrimaryKeyAttribute = 'com.infa.odin.models.erstudio.PrimaryKeyAttribute',
	PrimaryKeyColumn = 'com.infa.odin.models.erstudio.PrimaryKeyColumn',
	Project = 'com.infa.odin.models.erstudio.Project',
	ReferenceValueList = 'com.infa.odin.models.erstudio.ReferenceValueList',
	ReferenceValueRange = 'com.infa.odin.models.erstudio.ReferenceValueRange',
	Repository = 'com.infa.odin.models.erstudio.Repository',
	Rule = 'com.infa.odin.models.erstudio.Rule',
	Schema = 'com.infa.odin.models.erstudio.Schema',
	Sequence = 'com.infa.odin.models.erstudio.Sequence',
	SourceTable = 'com.infa.odin.models.erstudio.SourceTable',
	StoredProcedure = 'com.infa.odin.models.erstudio.StoredProcedure',
	SuperTypeRelationship = 'com.infa.odin.models.erstudio.SuperTypeRelationship',
	Synonym = 'com.infa.odin.models.erstudio.Synonym',
	Table = 'com.infa.odin.models.erstudio.Table',
	Transformation = 'com.infa.odin.models.erstudio.Transformation',
	Trigger = 'com.infa.odin.models.erstudio.Trigger',
	TypeValue = 'com.infa.odin.models.erstudio.TypeValue',
	UnnamedRelationshipEnd = 'com.infa.odin.models.erstudio.UnnamedRelationshipEnd',
	User = 'com.infa.odin.models.erstudio.User',
	UserDatatype = 'com.infa.odin.models.erstudio.UserDatatype',
	View = 'com.infa.odin.models.erstudio.View',
	ViewColumn = 'com.infa.odin.models.erstudio.ViewColumn',
	ViewRelationship = 'com.infa.odin.models.erstudio.ViewRelationship',
}

export enum ErwinClz {
	Argument = 'com.infa.odin.models.erwin.Argument',
	Attribute = 'com.infa.odin.models.erwin.Attribute',
	CandidateKeyGroup = 'com.infa.odin.models.erwin.CandidateKeyGroup',
	Column = 'com.infa.odin.models.erwin.Column',
	ColumnAttribute = 'com.infa.odin.models.erwin.ColumnAttribute',
	Condition = 'com.infa.odin.models.erwin.Condition',
	DB2Database = 'com.infa.odin.models.erwin.DB2Database',
	DataSource = 'com.infa.odin.models.erwin.DataSource',
	DataSourceFile = 'com.infa.odin.models.erwin.DataSourceFile',
	DataSourceSchema = 'com.infa.odin.models.erwin.DataSourceSchema',
	DataSourceTable = 'com.infa.odin.models.erwin.DataSourceTable',
	DatabaseSchema = 'com.infa.odin.models.erwin.DatabaseSchema',
	DefaultValue = 'com.infa.odin.models.erwin.DefaultValue',
	Directory = 'com.infa.odin.models.erwin.Directory',
	Domain = 'com.infa.odin.models.erwin.Domain',
	ERDiagram = 'com.infa.odin.models.erwin.ERDiagram',
	Entity = 'com.infa.odin.models.erwin.Entity',
	File = 'com.infa.odin.models.erwin.File',
	FileGroup = 'com.infa.odin.models.erwin.FileGroup',
	Folder = 'com.infa.odin.models.erwin.Folder',
	ForeignKeyGroup = 'com.infa.odin.models.erwin.ForeignKeyGroup',
	Identity = 'com.infa.odin.models.erwin.Identity',
	Index = 'com.infa.odin.models.erwin.Index',
	IndexMember = 'com.infa.odin.models.erwin.IndexMember',
	Library = 'com.infa.odin.models.erwin.Library',
	Mart = 'com.infa.odin.models.erwin.Mart',
	MinMax = 'com.infa.odin.models.erwin.MinMax',
	Model = 'com.infa.odin.models.erwin.Model',
	ModelSource = 'com.infa.odin.models.erwin.ModelSource',
	NamedRelationshipEnd = 'com.infa.odin.models.erwin.NamedRelationshipEnd',
	Note = 'com.infa.odin.models.erwin.Note',
	OracleDatabase = 'com.infa.odin.models.erwin.OracleDatabase',
	PrimaryKeyAttribute = 'com.infa.odin.models.erwin.PrimaryKeyAttribute',
	PrimaryKeyColumn = 'com.infa.odin.models.erwin.PrimaryKeyColumn',
	PrimaryKeyColumnAttribute = 'com.infa.odin.models.erwin.PrimaryKeyColumnAttribute',
	Relationship = 'com.infa.odin.models.erwin.Relationship',
	SQLServerDatabase = 'com.infa.odin.models.erwin.SQLServerDatabase',
	Sequence = 'com.infa.odin.models.erwin.Sequence',
	StorageGroup = 'com.infa.odin.models.erwin.StorageGroup',
	StoredProcedure = 'com.infa.odin.models.erwin.StoredProcedure',
	SubjectArea = 'com.infa.odin.models.erwin.SubjectArea',
	SubtypeRelationship = 'com.infa.odin.models.erwin.SubtypeRelationship',
	SubtypeRelationshipRole = 'com.infa.odin.models.erwin.SubtypeRelationshipRole',
	Synonym = 'com.infa.odin.models.erwin.Synonym',
	Table = 'com.infa.odin.models.erwin.Table',
	TableEntity = 'com.infa.odin.models.erwin.TableEntity',
	Template = 'com.infa.odin.models.erwin.Template',
	Trigger = 'com.infa.odin.models.erwin.Trigger',
	TypeValue = 'com.infa.odin.models.erwin.TypeValue',
	UDP = 'com.infa.odin.models.erwin.UDP',
	UDPs = 'com.infa.odin.models.erwin.UDPs',
	UnnamedRelationshipEnd = 'com.infa.odin.models.erwin.UnnamedRelationshipEnd',
	UserDefined = 'com.infa.odin.models.erwin.UserDefined',
	ValidValuesList = 'com.infa.odin.models.erwin.ValidValuesList',
	View = 'com.infa.odin.models.erwin.View',
	ViewColumn = 'com.infa.odin.models.erwin.ViewColumn',
	ViewRelationship = 'com.infa.odin.models.erwin.ViewRelationship',
}

export enum FileAdlsClz {
	Container = 'com.infa.odin.models.file.adls.Container',
	StorageAccount = 'com.infa.odin.models.file.adls.StorageAccount',
}

export enum FileAmazonS3Clz {
	Bucket = 'com.infa.odin.models.file.amazons3.Bucket',
}

export enum FileAzureBlobClz {
	Container = 'com.infa.odin.models.file.azureblob.Container',
	StorageAccount = 'com.infa.odin.models.file.azureblob.StorageAccount',
}

export enum FileClz {
	Field = 'com.infa.odin.models.file.Field',
	File = 'com.infa.odin.models.file.File',
	FileSystem = 'com.infa.odin.models.file.FileSystem',
	FileSystemContainer = 'com.infa.odin.models.file.FileSystemContainer',
	Folder = 'com.infa.odin.models.file.Folder',
}

export enum FileExcelClz {
	Column = 'com.infa.odin.models.file.excel.Column',
	Workbook = 'com.infa.odin.models.file.excel.Workbook',
	Worksheet = 'com.infa.odin.models.file.excel.Worksheet',
}

export enum FileFlatClz {
	FlatField = 'com.infa.odin.models.file.flat.FlatField',
	FlatFile = 'com.infa.odin.models.file.flat.FlatFile',
}

export enum FileGCSClz {
	Bucket = 'com.infa.odin.models.file.gcs.Bucket',
	Project = 'com.infa.odin.models.file.gcs.Project',
}

export enum FileHierarchicalClz {
	HierarchicalField = 'com.infa.odin.models.file.hierarchical.HierarchicalField',
	HierarchicalFile = 'com.infa.odin.models.file.hierarchical.HierarchicalFile',
}

export enum FileOciObjectstorageClz {
	Bucket = 'com.infa.odin.models.file.oci.objectstorage.Bucket',
}

export enum FileOfficeClz {
	Document = 'com.infa.odin.models.file.office.Document',
}

export enum FileSharepointClz {
	DocumentLibrary = 'com.infa.odin.models.file.sharepoint.DocumentLibrary',
	Site = 'com.infa.odin.models.file.sharepoint.Site',
	SubSite = 'com.infa.odin.models.file.sharepoint.SubSite',
}

export enum FileUnstructuredClz {
	UnstructuredField = 'com.infa.odin.models.file.unstructured.UnstructuredField',
	UnstructuredFile = 'com.infa.odin.models.file.unstructured.UnstructuredFile',
}

export enum GlueClz {
	Calculation = 'com.infa.odin.models.Glue.Calculation',
	Job = 'com.infa.odin.models.Glue.Job',
	JobInstance = 'com.infa.odin.models.Glue.JobInstance',
}

export enum GovernanceClz {
	BusinessArea = 'com.infa.ccgf.models.governance.BusinessArea',
	BusinessTerm = 'com.infa.ccgf.models.governance.BusinessTerm',
	DQProfileRun = 'com.infa.ccgf.models.governance.DQProfileRun',
	DQResult = 'com.infa.ccgf.models.governance.DQResult',
	DQScoreAggregationBucket = 'com.infa.ccgf.models.governance.DQScoreAggregationBucket',
	DataSet = 'com.infa.ccgf.models.governance.DataSet',
	Domain = 'com.infa.ccgf.models.governance.Domain',
	Geography = 'com.infa.ccgf.models.governance.Geography',
	GlossaryBase = 'com.infa.ccgf.models.governance.GlossaryBase',
	LegalEntity = 'com.infa.ccgf.models.governance.LegalEntity',
	Metric = 'com.infa.ccgf.models.governance.Metric',
	Policy = 'com.infa.ccgf.models.governance.Policy',
	Process = 'com.infa.ccgf.models.governance.Process',
	Project = 'com.infa.ccgf.models.governance.Project',
	Regulation = 'com.infa.ccgf.models.governance.Regulation',
	Report = 'com.infa.ccgf.models.governance.Report',
	RuleInstance = 'com.infa.ccgf.models.governance.RuleInstance',
	RuleTemplate = 'com.infa.ccgf.models.governance.RuleTemplate',
	SubDomain = 'com.infa.ccgf.models.governance.SubDomain',
	System = 'com.infa.ccgf.models.governance.System',
	SystemInterface = 'com.infa.ccgf.models.governance.SystemInterface',
}

export enum IICSClz {
	Calculation = 'com.infa.odin.models.IICS.Calculation',
	Folder = 'com.infa.odin.models.IICS.Folder',
	LogSessionExecutionData = 'com.infa.odin.models.IICS.LogSessionExecutionData',
	LogWorkflowExecutionData = 'com.infa.odin.models.IICS.LogWorkflowExecutionData',
	Mapping = 'com.infa.odin.models.IICS.Mapping',
	Repository = 'com.infa.odin.models.IICS.Repository',
	Session = 'com.infa.odin.models.IICS.Session',
	SessionExecution = 'com.infa.odin.models.IICS.SessionExecution',
	SessionExecutionData = 'com.infa.odin.models.IICS.SessionExecutionData',
	SessionInstance = 'com.infa.odin.models.IICS.SessionInstance',
	Workflow = 'com.infa.odin.models.IICS.Workflow',
	WorkflowExecution = 'com.infa.odin.models.IICS.WorkflowExecution',
	WorkflowExecutionData = 'com.infa.odin.models.IICS.WorkflowExecutionData',
	WorkflowInstance = 'com.infa.odin.models.IICS.WorkflowInstance',
	Worklet = 'com.infa.odin.models.IICS.Worklet',
	WorkletInstance = 'com.infa.odin.models.IICS.WorkletInstance',
}

export enum IICSV2Clz {
	BusinessEntity = 'com.infa.odin.models.IICS.V2.BusinessEntity',
	Calculation = 'com.infa.odin.models.IICS.V2.Calculation',
	Field = 'com.infa.odin.models.IICS.V2.Field',
	Folder = 'com.infa.odin.models.IICS.V2.Folder',
	Mapping = 'com.infa.odin.models.IICS.V2.Mapping',
	MappingTask = 'com.infa.odin.models.IICS.V2.MappingTask',
	MappingTaskInstance = 'com.infa.odin.models.IICS.V2.MappingTaskInstance',
	PowerCenterTask = 'com.infa.odin.models.IICS.V2.PowerCenterTask',
	PowerCenterTaskInstance = 'com.infa.odin.models.IICS.V2.PowerCenterTaskInstance',
	Project = 'com.infa.odin.models.IICS.V2.Project',
	SynchronizationTask = 'com.infa.odin.models.IICS.V2.SynchronizationTask',
	SynchronizationTaskInstance = 'com.infa.odin.models.IICS.V2.SynchronizationTaskInstance',
	SystemField = 'com.infa.odin.models.IICS.V2.SystemField',
	Task = 'com.infa.odin.models.IICS.V2.Task',
	TaskInstance = 'com.infa.odin.models.IICS.V2.TaskInstance',
}

export enum IPCClz {
	Calculation = 'com.infa.odin.models.IPC.Calculation',
	Folder = 'com.infa.odin.models.IPC.Folder',
	LogSessionExecutionData = 'com.infa.odin.models.IPC.LogSessionExecutionData',
	LogWorkflowExecutionData = 'com.infa.odin.models.IPC.LogWorkflowExecutionData',
	Mapping = 'com.infa.odin.models.IPC.Mapping',
	Repository = 'com.infa.odin.models.IPC.Repository',
	Session = 'com.infa.odin.models.IPC.Session',
	SessionExecution = 'com.infa.odin.models.IPC.SessionExecution',
	SessionExecutionData = 'com.infa.odin.models.IPC.SessionExecutionData',
	SessionInstance = 'com.infa.odin.models.IPC.SessionInstance',
	Workflow = 'com.infa.odin.models.IPC.Workflow',
	WorkflowExecution = 'com.infa.odin.models.IPC.WorkflowExecution',
	WorkflowExecutionData = 'com.infa.odin.models.IPC.WorkflowExecutionData',
	WorkflowInstance = 'com.infa.odin.models.IPC.WorkflowInstance',
	Worklet = 'com.infa.odin.models.IPC.Worklet',
	WorkletInstance = 'com.infa.odin.models.IPC.WorkletInstance',
}

export enum LakeHouseClz {
	LakehouseTable = 'com.infa.odin.models.lakehouse.LakehouseTable',
	LakehouseView = 'com.infa.odin.models.lakehouse.LakehouseView',
}

export enum LookerClz {
	Column = 'com.infa.odin.models.looker.Column',
	Connection = 'com.infa.odin.models.looker.Connection',
	ConnectionModel = 'com.infa.odin.models.looker.ConnectionModel',
	Dashboard = 'com.infa.odin.models.looker.Dashboard',
	DatabaseSchema = 'com.infa.odin.models.looker.DatabaseSchema',
	Dimension = 'com.infa.odin.models.looker.Dimension',
	ExploreDiagram = 'com.infa.odin.models.looker.ExploreDiagram',
	Field = 'com.infa.odin.models.looker.Field',
	Filter = 'com.infa.odin.models.looker.Filter',
	Folder = 'com.infa.odin.models.looker.Folder',
	Join = 'com.infa.odin.models.looker.Join',
	Look = 'com.infa.odin.models.looker.Look',
	Measure = 'com.infa.odin.models.looker.Measure',
	Model = 'com.infa.odin.models.looker.Model',
	Parameter = 'com.infa.odin.models.looker.Parameter',
	Project = 'com.infa.odin.models.looker.Project',
	Query = 'com.infa.odin.models.looker.Query',
	QueryField = 'com.infa.odin.models.looker.QueryField',
	Schema = 'com.infa.odin.models.looker.Schema',
	Server = 'com.infa.odin.models.looker.Server',
	Table = 'com.infa.odin.models.looker.Table',
	Text = 'com.infa.odin.models.looker.Text',
	View = 'com.infa.odin.models.looker.View',
}

export enum MarketPlaceClz {
	AdminSetting = 'com.infa.cdmp.marketplace.AdminSetting',
	AssetType = 'com.infa.cdmp.marketplace.AssetType',
	BatchFileRecord = 'com.infa.cdmp.marketplace.BatchFileRecord',
	BatchFileUnprocessed = 'com.infa.cdmp.marketplace.BatchFileUnprocessed',
	BatchJobExecution = 'com.infa.cdmp.marketplace.BatchJobExecution',
	BatchJobExecutionContext = 'com.infa.cdmp.marketplace.BatchJobExecutionContext',
	BatchJobExecutionParams = 'com.infa.cdmp.marketplace.BatchJobExecutionParams',
	BatchJobInstance = 'com.infa.cdmp.marketplace.BatchJobInstance',
	Category = 'com.infa.cdmp.marketplace.Category',
	ComponentConfiguration = 'com.infa.cdmp.marketplace.ComponentConfiguration',
	ConsumerAccess = 'com.infa.cdmp.marketplace.ConsumerAccess',
	CostCenter = 'com.infa.cdmp.marketplace.CostCenter',
	DataAsset = 'com.infa.cdmp.marketplace.DataAsset',
	DataCollection = 'com.infa.cdmp.marketplace.DataCollection',
	DataElement = 'com.infa.cdmp.marketplace.DataElement',
	DeliveryFormat = 'com.infa.cdmp.marketplace.DeliveryFormat',
	DeliveryMethod = 'com.infa.cdmp.marketplace.DeliveryMethod',
	DeliveryTarget = 'com.infa.cdmp.marketplace.DeliveryTarget',
	DeliveryTemplate = 'com.infa.cdmp.marketplace.DeliveryTemplate',
	IClassMarketplace = 'com.infa.cdmp.marketplace.IClassMarketplace',
	IntegrationSource = 'com.infa.cdmp.marketplace.IntegrationSource',
	LifeCycleComment = 'com.infa.cdmp.marketplace.LifeCycleComment',
	MarketplaceUserProfile = 'com.infa.cdmp.marketplace.MarketplaceUserProfile',
	Metric = 'com.infa.cdmp.marketplace.Metric',
	MetricConfig = 'com.infa.cdmp.marketplace.MetricConfig',
	MetricTarget = 'com.infa.cdmp.marketplace.MetricTarget',
	Order = 'com.infa.cdmp.marketplace.Order',
	Payload = 'com.infa.cdmp.marketplace.Payload',
	RequestNewDataCollection = 'com.infa.cdmp.marketplace.RequestNewDataCollection',
	ResourceReference = 'com.infa.cdmp.marketplace.ResourceReference',
	SearchConfiguration = 'com.infa.cdmp.marketplace.SearchConfiguration',
	TermsOfUse = 'com.infa.cdmp.marketplace.TermsOfUse',
	TermsOfUseSnapshot = 'com.infa.cdmp.marketplace.TermsOfUseSnapshot',
	UsageContext = 'com.infa.cdmp.marketplace.UsageContext',
}

export enum MessagingClz {
	Collection = 'com.infa.odin.models.messaging.Collection',
	Field = 'com.infa.odin.models.messaging.Field',
	MessageSystem = 'com.infa.odin.models.messaging.MessageSystem',
}

export enum MessagingKafkaClz {
	Cluster = 'com.infa.odin.models.messaging.kafka.Cluster',
	Topic = 'com.infa.odin.models.messaging.kafka.Topic',
}

export enum MstrClz {
	Attribute = 'com.infa.odin.models.mstr.Attribute',
	AttributeForm = 'com.infa.odin.models.mstr.AttributeForm',
	CalculatedReportField = 'com.infa.odin.models.mstr.CalculatedReportField',
	Column = 'com.infa.odin.models.mstr.Column',
	Consolidation = 'com.infa.odin.models.mstr.Consolidation',
	ConsolidationElement = 'com.infa.odin.models.mstr.ConsolidationElement',
	ConsolidationModel = 'com.infa.odin.models.mstr.ConsolidationModel',
	CustomGroup = 'com.infa.odin.models.mstr.CustomGroup',
	CustomGroupModel = 'com.infa.odin.models.mstr.CustomGroupModel',
	DatabaseInstance = 'com.infa.odin.models.mstr.DatabaseInstance',
	DatabaseSchema = 'com.infa.odin.models.mstr.DatabaseSchema',
	Dataset = 'com.infa.odin.models.mstr.Dataset',
	Document = 'com.infa.odin.models.mstr.Document',
	DocumentReport = 'com.infa.odin.models.mstr.DocumentReport',
	Expression = 'com.infa.odin.models.mstr.Expression',
	Fact = 'com.infa.odin.models.mstr.Fact',
	FactMeasure = 'com.infa.odin.models.mstr.FactMeasure',
	Filter = 'com.infa.odin.models.mstr.Filter',
	FilterModel = 'com.infa.odin.models.mstr.FilterModel',
	Folder = 'com.infa.odin.models.mstr.Folder',
	HTMLDocument = 'com.infa.odin.models.mstr.HTMLDocument',
	HTMLDocumentReport = 'com.infa.odin.models.mstr.HTMLDocumentReport',
	HiddenFolder = 'com.infa.odin.models.mstr.HiddenFolder',
	Hierarchy = 'com.infa.odin.models.mstr.Hierarchy',
	IntelligentCube = 'com.infa.odin.models.mstr.IntelligentCube',
	IntelligentCubeReport = 'com.infa.odin.models.mstr.IntelligentCubeReport',
	LogicalQueryTable = 'com.infa.odin.models.mstr.LogicalQueryTable',
	LogicalTable = 'com.infa.odin.models.mstr.LogicalTable',
	Lookup = 'com.infa.odin.models.mstr.Lookup',
	Metric = 'com.infa.odin.models.mstr.Metric',
	MetricMeasure = 'com.infa.odin.models.mstr.MetricMeasure',
	MetricModel = 'com.infa.odin.models.mstr.MetricModel',
	Project = 'com.infa.odin.models.mstr.Project',
	ProjectSource = 'com.infa.odin.models.mstr.ProjectSource',
	Prompt = 'com.infa.odin.models.mstr.Prompt',
	PromptAnswer = 'com.infa.odin.models.mstr.PromptAnswer',
	PromptModel = 'com.infa.odin.models.mstr.PromptModel',
	QueryBuilderDefinition = 'com.infa.odin.models.mstr.QueryBuilderDefinition',
	Report = 'com.infa.odin.models.mstr.Report',
	SQLAttributeForm = 'com.infa.odin.models.mstr.SQLAttributeForm',
	SQLColumn = 'com.infa.odin.models.mstr.SQLColumn',
	SQLMetric = 'com.infa.odin.models.mstr.SQLMetric',
	Schema = 'com.infa.odin.models.mstr.Schema',
	SecurityFilter = 'com.infa.odin.models.mstr.SecurityFilter',
	SecurityFilterModel = 'com.infa.odin.models.mstr.SecurityFilterModel',
	Subtotal = 'com.infa.odin.models.mstr.Subtotal',
	SubtotalMeasure = 'com.infa.odin.models.mstr.SubtotalMeasure',
	SubtotalModel = 'com.infa.odin.models.mstr.SubtotalModel',
	Threshold = 'com.infa.odin.models.mstr.Threshold',
	WarehouseTable = 'com.infa.odin.models.mstr.WarehouseTable',
}

export enum PowerBICloudClz {
	Dashboard = 'com.infa.odin.models.PowerBI.Cloud.Dashboard',
	Datamart = 'com.infa.odin.models.PowerBI.Cloud.Datamart',
	Dataset = 'com.infa.odin.models.PowerBI.Cloud.Dataset',
	Field = 'com.infa.odin.models.PowerBI.Cloud.Field',
	Report = 'com.infa.odin.models.PowerBI.Cloud.Report',
	Tile = 'com.infa.odin.models.PowerBI.Cloud.Tile',
	Workspace = 'com.infa.odin.models.PowerBI.Cloud.Workspace',
}

export enum PurviewClz {
	Collection = 'com.infa.odin.models.Purview.Collection',
}

export enum QlikSenseClz {
	App = 'com.infa.odin.models.qlikSense.App',
	AppModel = 'com.infa.odin.models.qlikSense.AppModel',
	Column = 'com.infa.odin.models.qlikSense.Column',
	Condition = 'com.infa.odin.models.qlikSense.Condition',
	Connection = 'com.infa.odin.models.qlikSense.Connection',
	ConnectionSchema = 'com.infa.odin.models.qlikSense.ConnectionSchema',
	DatabaseSchema = 'com.infa.odin.models.qlikSense.DatabaseSchema',
	Dimension = 'com.infa.odin.models.qlikSense.Dimension',
	DimensionAttribute = 'com.infa.odin.models.qlikSense.DimensionAttribute',
	Document = 'com.infa.odin.models.qlikSense.Document',
	Expression = 'com.infa.odin.models.qlikSense.Expression',
	Field = 'com.infa.odin.models.qlikSense.Field',
	File = 'com.infa.odin.models.qlikSense.File',
	FileDirectory = 'com.infa.odin.models.qlikSense.FileDirectory',
	Folder = 'com.infa.odin.models.qlikSense.Folder',
	Hub = 'com.infa.odin.models.qlikSense.Hub',
	Measure = 'com.infa.odin.models.qlikSense.Measure',
	MeasureAttribute = 'com.infa.odin.models.qlikSense.MeasureAttribute',
	QVD = 'com.infa.odin.models.qlikSense.QVD',
	QVDModel = 'com.infa.odin.models.qlikSense.QVDModel',
	SourceColumn = 'com.infa.odin.models.qlikSense.SourceColumn',
	SourceTable = 'com.infa.odin.models.qlikSense.SourceTable',
	Story = 'com.infa.odin.models.qlikSense.Story',
	Stream = 'com.infa.odin.models.qlikSense.Stream',
	SystemField = 'com.infa.odin.models.qlikSense.SystemField',
	Table = 'com.infa.odin.models.qlikSense.Table',
}

export enum QlikViewClz {
	Application = 'com.infa.odin.models.qlikView.Application',
	ButtonField = 'com.infa.odin.models.qlikView.ButtonField',
	Column = 'com.infa.odin.models.qlikView.Column',
	Condition = 'com.infa.odin.models.qlikView.Condition',
	Connection = 'com.infa.odin.models.qlikView.Connection',
	ConnectionModel = 'com.infa.odin.models.qlikView.ConnectionModel',
	ConnectionSchema = 'com.infa.odin.models.qlikView.ConnectionSchema',
	DatabaseSchema = 'com.infa.odin.models.qlikView.DatabaseSchema',
	Document = 'com.infa.odin.models.qlikView.Document',
	Expression = 'com.infa.odin.models.qlikView.Expression',
	Field = 'com.infa.odin.models.qlikView.Field',
	File = 'com.infa.odin.models.qlikView.File',
	FileDirectory = 'com.infa.odin.models.qlikView.FileDirectory',
	Folder = 'com.infa.odin.models.qlikView.Folder',
	Group = 'com.infa.odin.models.qlikView.Group',
	Measure = 'com.infa.odin.models.qlikView.Measure',
	QVD = 'com.infa.odin.models.qlikView.QVD',
	QVDModel = 'com.infa.odin.models.qlikView.QVDModel',
	QVW = 'com.infa.odin.models.qlikView.QVW',
	QVWModel = 'com.infa.odin.models.qlikView.QVWModel',
	SourceColumn = 'com.infa.odin.models.qlikView.SourceColumn',
	SourceFile = 'com.infa.odin.models.qlikView.SourceFile',
	SourceTable = 'com.infa.odin.models.qlikView.SourceTable',
	SystemField = 'com.infa.odin.models.qlikView.SystemField',
	SystemVariable = 'com.infa.odin.models.qlikView.SystemVariable',
	Table = 'com.infa.odin.models.qlikView.Table',
	TextField = 'com.infa.odin.models.qlikView.TextField',
	Variable = 'com.infa.odin.models.qlikView.Variable',
}

export enum RelationalClz {
	Attribute = 'com.infa.odin.models.relational.Attribute',
	Calculation = 'com.infa.odin.models.relational.Calculation',
	CalculationView = 'com.infa.odin.models.relational.CalculationView',
	Column = 'com.infa.odin.models.relational.Column',
	Database = 'com.infa.odin.models.relational.Database',
	ExternalColumn = 'com.infa.odin.models.relational.ExternalColumn',
	ExternalTable = 'com.infa.odin.models.relational.ExternalTable',
	ForeignKey = 'com.infa.odin.models.relational.ForeignKey',
	Package = 'com.infa.odin.models.relational.Package',
	Parameter = 'com.infa.odin.models.relational.Parameter',
	Parameters = 'com.infa.odin.models.relational.Parameters',
	Pipe = 'com.infa.odin.models.relational.Pipe',
	PrimaryKey = 'com.infa.odin.models.relational.PrimaryKey',
	ProcedureDefinition = 'com.infa.odin.models.relational.ProcedureDefinition',
	ProcedureInstance = 'com.infa.odin.models.relational.ProcedureInstance',
	ProcedureSource = 'com.infa.odin.models.relational.ProcedureSource',
	ResultSet = 'com.infa.odin.models.relational.ResultSet',
	ResultSetColumn = 'com.infa.odin.models.relational.ResultSetColumn',
	SAPHanaPackage = 'com.infa.odin.models.relational.SAPHanaPackage',
	Schema = 'com.infa.odin.models.relational.Schema',
	Sequence = 'com.infa.odin.models.relational.Sequence',
	SequenceColumn = 'com.infa.odin.models.relational.SequenceColumn',
	SourceColumn = 'com.infa.odin.models.relational.SourceColumn',
	Stage = 'com.infa.odin.models.relational.Stage',
	StageColumn = 'com.infa.odin.models.relational.StageColumn',
	Statement = 'com.infa.odin.models.relational.Statement',
	Table = 'com.infa.odin.models.relational.Table',
	Tag = 'com.infa.odin.models.relational.Tag',
	Task = 'com.infa.odin.models.relational.Task',
	Trigger = 'com.infa.odin.models.relational.Trigger',
	UnresolvedProcedureDefinition = 'com.infa.odin.models.relational.UnresolvedProcedureDefinition',
	UnresolvedStatement = 'com.infa.odin.models.relational.UnresolvedStatement',
	UnresolvedView = 'com.infa.odin.models.relational.UnresolvedView',
	View = 'com.infa.odin.models.relational.View',
	ViewColumn = 'com.infa.odin.models.relational.ViewColumn',
}

export enum SAPBOClz {
	AliasColumn = 'com.infa.odin.models.SAPBO.AliasColumn',
	AliasTable = 'com.infa.odin.models.SAPBO.AliasTable',
	AnalyticModel = 'com.infa.odin.models.SAPBO.AnalyticModel',
	AnalyticReport = 'com.infa.odin.models.SAPBO.AnalyticReport',
	BusinessLayerView = 'com.infa.odin.models.SAPBO.BusinessLayerView',
	Category = 'com.infa.odin.models.SAPBO.Category',
	Cell = 'com.infa.odin.models.SAPBO.Cell',
	Class = 'com.infa.odin.models.SAPBO.Class',
	Column = 'com.infa.odin.models.SAPBO.Column',
	Connection = 'com.infa.odin.models.SAPBO.Connection',
	ConnectionClassifier = 'com.infa.odin.models.SAPBO.ConnectionClassifier',
	ConnectionFeature = 'com.infa.odin.models.SAPBO.ConnectionFeature',
	ConnectionFolder = 'com.infa.odin.models.SAPBO.ConnectionFolder',
	ConnectionModel = 'com.infa.odin.models.SAPBO.ConnectionModel',
	Constants = 'com.infa.odin.models.SAPBO.Constants',
	Context = 'com.infa.odin.models.SAPBO.Context',
	Contexts = 'com.infa.odin.models.SAPBO.Contexts',
	CrystalReport = 'com.infa.odin.models.SAPBO.CrystalReport',
	CrystalReportModel = 'com.infa.odin.models.SAPBO.CrystalReportModel',
	CustomHierarchies = 'com.infa.odin.models.SAPBO.CustomHierarchies',
	Dashboard = 'com.infa.odin.models.SAPBO.Dashboard',
	DataProvider = 'com.infa.odin.models.SAPBO.DataProvider',
	DataProviders = 'com.infa.odin.models.SAPBO.DataProviders',
	DatabaseConnection = 'com.infa.odin.models.SAPBO.DatabaseConnection',
	DefaultHierarchies = 'com.infa.odin.models.SAPBO.DefaultHierarchies',
	DerivedTable = 'com.infa.odin.models.SAPBO.DerivedTable',
	DesktopIntelligenceDocument = 'com.infa.odin.models.SAPBO.DesktopIntelligenceDocument',
	DesktopIntelligenceModel = 'com.infa.odin.models.SAPBO.DesktopIntelligenceModel',
	Detail = 'com.infa.odin.models.SAPBO.Detail',
	DetailResult = 'com.infa.odin.models.SAPBO.DetailResult',
	DetailVariable = 'com.infa.odin.models.SAPBO.DetailVariable',
	Dimension = 'com.infa.odin.models.SAPBO.Dimension',
	DimensionResult = 'com.infa.odin.models.SAPBO.DimensionResult',
	DimensionVariable = 'com.infa.odin.models.SAPBO.DimensionVariable',
	DiscoveredTables = 'com.infa.odin.models.SAPBO.DiscoveredTables',
	EnterpriseFolder = 'com.infa.odin.models.SAPBO.EnterpriseFolder',
	FavoriteFolder = 'com.infa.odin.models.SAPBO.FavoriteFolder',
	Field = 'com.infa.odin.models.SAPBO.Field',
	File = 'com.infa.odin.models.SAPBO.File',
	FileConnection = 'com.infa.odin.models.SAPBO.FileConnection',
	Filter = 'com.infa.odin.models.SAPBO.Filter',
	Folder = 'com.infa.odin.models.SAPBO.Folder',
	FormulaFields = 'com.infa.odin.models.SAPBO.FormulaFields',
	Formulas = 'com.infa.odin.models.SAPBO.Formulas',
	GroupNameFields = 'com.infa.odin.models.SAPBO.GroupNameFields',
	Hierarchy = 'com.infa.odin.models.SAPBO.Hierarchy',
	Inbox = 'com.infa.odin.models.SAPBO.Inbox',
	Join = 'com.infa.odin.models.SAPBO.Join',
	Key = 'com.infa.odin.models.SAPBO.Key',
	ListOfValues = 'com.infa.odin.models.SAPBO.ListOfValues',
	LogicalColumn = 'com.infa.odin.models.SAPBO.LogicalColumn',
	Measure = 'com.infa.odin.models.SAPBO.Measure',
	MeasureResult = 'com.infa.odin.models.SAPBO.MeasureResult',
	MeasureVariable = 'com.infa.odin.models.SAPBO.MeasureVariable',
	MergedDimensions = 'com.infa.odin.models.SAPBO.MergedDimensions',
	ObjectPackage = 'com.infa.odin.models.SAPBO.ObjectPackage',
	OlapConnection = 'com.infa.odin.models.SAPBO.OlapConnection',
	OlapDimension = 'com.infa.odin.models.SAPBO.OlapDimension',
	Parameter = 'com.infa.odin.models.SAPBO.Parameter',
	ParameterAnswer = 'com.infa.odin.models.SAPBO.ParameterAnswer',
	ParameterPrompt = 'com.infa.odin.models.SAPBO.ParameterPrompt',
	PersonalCategory = 'com.infa.odin.models.SAPBO.PersonalCategory',
	ProcedureQuery = 'com.infa.odin.models.SAPBO.ProcedureQuery',
	ProcedureTable = 'com.infa.odin.models.SAPBO.ProcedureTable',
	Query = 'com.infa.odin.models.SAPBO.Query',
	QueryFilter = 'com.infa.odin.models.SAPBO.QueryFilter',
	ReportField = 'com.infa.odin.models.SAPBO.ReportField',
	ReportFilter = 'com.infa.odin.models.SAPBO.ReportFilter',
	ReportFolder = 'com.infa.odin.models.SAPBO.ReportFolder',
	Repository = 'com.infa.odin.models.SAPBO.Repository',
	RunningTotalFields = 'com.infa.odin.models.SAPBO.RunningTotalFields',
	SQLExpressionFields = 'com.infa.odin.models.SAPBO.SQLExpressionFields',
	SQLQuery = 'com.infa.odin.models.SAPBO.SQLQuery',
	Schema = 'com.infa.odin.models.SAPBO.Schema',
	SpecialFields = 'com.infa.odin.models.SAPBO.SpecialFields',
	SummaryFields = 'com.infa.odin.models.SAPBO.SummaryFields',
	Table = 'com.infa.odin.models.SAPBO.Table',
	Universe = 'com.infa.odin.models.SAPBO.Universe',
	UniverseConnection = 'com.infa.odin.models.SAPBO.UniverseConnection',
	UniverseFolder = 'com.infa.odin.models.SAPBO.UniverseFolder',
	UniverseModel = 'com.infa.odin.models.SAPBO.UniverseModel',
	UniverseQuery = 'com.infa.odin.models.SAPBO.UniverseQuery',
	Value = 'com.infa.odin.models.SAPBO.Value',
	Variables = 'com.infa.odin.models.SAPBO.Variables',
	View = 'com.infa.odin.models.SAPBO.View',
	WebIntelligenceDocument = 'com.infa.odin.models.SAPBO.WebIntelligenceDocument',
	WebIntelligenceModel = 'com.infa.odin.models.SAPBO.WebIntelligenceModel',
	XMLQuery = 'com.infa.odin.models.SAPBO.XMLQuery',
}

export enum SAPBWClz {
	AdvancedDSO = 'com.infa.odin.models.warehouse.sapbw.AdvancedDSO',
	AggregateLevel = 'com.infa.odin.models.warehouse.sapbw.AggregateLevel',
	AggregateLevelFilter = 'com.infa.odin.models.warehouse.sapbw.AggregateLevelFilter',
	CDSView = 'com.infa.odin.models.warehouse.sapbw.CDSView',
	CharacteristicsField = 'com.infa.odin.models.warehouse.sapbw.CharacteristicsField',
	CompositeProvider = 'com.infa.odin.models.warehouse.sapbw.CompositeProvider',
	DSOOnlyField = 'com.infa.odin.models.warehouse.sapbw.DSOOnlyField',
	DataStoreObject = 'com.infa.odin.models.warehouse.sapbw.DataStoreObject',
	DataTransferProcess = 'com.infa.odin.models.warehouse.sapbw.DataTransferProcess',
	DimensionField = 'com.infa.odin.models.warehouse.sapbw.DimensionField',
	Field = 'com.infa.odin.models.warehouse.sapbw.Field',
	Group = 'com.infa.odin.models.warehouse.sapbw.Group',
	HybridProvider = 'com.infa.odin.models.warehouse.sapbw.HybridProvider',
	InfoArea = 'com.infa.odin.models.warehouse.sapbw.InfoArea',
	InfoCube = 'com.infa.odin.models.warehouse.sapbw.InfoCube',
	InfoObject = 'com.infa.odin.models.warehouse.sapbw.InfoObject',
	InfoObjectCatalog = 'com.infa.odin.models.warehouse.sapbw.InfoObjectCatalog',
	InfoObjectInfoProvider = 'com.infa.odin.models.warehouse.sapbw.InfoObjectInfoProvider',
	InfoProvider = 'com.infa.odin.models.warehouse.sapbw.InfoProvider',
	InfoProviderField = 'com.infa.odin.models.warehouse.sapbw.InfoProviderField',
	InfoSet = 'com.infa.odin.models.warehouse.sapbw.InfoSet',
	InfoSource = 'com.infa.odin.models.warehouse.sapbw.InfoSource',
	KeyFiguresField = 'com.infa.odin.models.warehouse.sapbw.KeyFiguresField',
	MultiProvider = 'com.infa.odin.models.warehouse.sapbw.MultiProvider',
	NavigationalAttributeField = 'com.infa.odin.models.warehouse.sapbw.NavigationalAttributeField',
	Query = 'com.infa.odin.models.warehouse.sapbw.Query',
	QueryField = 'com.infa.odin.models.warehouse.sapbw.QueryField',
	SapDataSource = 'com.infa.odin.models.warehouse.sapbw.SapDataSource',
	SapDataSourceField = 'com.infa.odin.models.warehouse.sapbw.SapDataSourceField',
	SapSchema = 'com.infa.odin.models.warehouse.sapbw.SapSchema',
	SourceSystemConnection = 'com.infa.odin.models.warehouse.sapbw.SourceSystemConnection',
	Transformation = 'com.infa.odin.models.warehouse.sapbw.Transformation',
	TransformationRule = 'com.infa.odin.models.warehouse.sapbw.TransformationRule',
	WorkBook = 'com.infa.odin.models.warehouse.sapbw.WorkBook',
}

export enum SAPBWHanaClz {
	AdvancedDSO = 'com.infa.odin.models.warehouse.sapbwhana.AdvancedDSO',
	AggregateLevel = 'com.infa.odin.models.warehouse.sapbwhana.AggregateLevel',
	CharacteristicsField = 'com.infa.odin.models.warehouse.sapbwhana.CharacteristicsField',
	CompositeProvider = 'com.infa.odin.models.warehouse.sapbwhana.CompositeProvider',
	DataTransferProcess = 'com.infa.odin.models.warehouse.sapbwhana.DataTransferProcess',
	Field = 'com.infa.odin.models.warehouse.sapbwhana.Field',
	Group = 'com.infa.odin.models.warehouse.sapbwhana.Group',
	InfoArea = 'com.infa.odin.models.warehouse.sapbwhana.InfoArea',
	InfoObject = 'com.infa.odin.models.warehouse.sapbwhana.InfoObject',
	InfoObjectInfoProvider = 'com.infa.odin.models.warehouse.sapbwhana.InfoObjectInfoProvider',
	InfoProvider = 'com.infa.odin.models.warehouse.sapbwhana.InfoProvider',
	InfoProviderField = 'com.infa.odin.models.warehouse.sapbwhana.InfoProviderField',
	InfoSource = 'com.infa.odin.models.warehouse.sapbwhana.InfoSource',
	KeyFiguresField = 'com.infa.odin.models.warehouse.sapbwhana.KeyFiguresField',
	NavigationalAttributeField = 'com.infa.odin.models.warehouse.sapbwhana.NavigationalAttributeField',
	OpenHubDestination = 'com.infa.odin.models.warehouse.sapbwhana.OpenHubDestination',
	OpenODSView = 'com.infa.odin.models.warehouse.sapbwhana.OpenODSView',
	Query = 'com.infa.odin.models.warehouse.sapbwhana.Query',
	QueryField = 'com.infa.odin.models.warehouse.sapbwhana.QueryField',
	SapDataSource = 'com.infa.odin.models.warehouse.sapbwhana.SapDataSource',
	SapDataSourceField = 'com.infa.odin.models.warehouse.sapbwhana.SapDataSourceField',
	SapSchema = 'com.infa.odin.models.warehouse.sapbwhana.SapSchema',
	SourceSystemConnection = 'com.infa.odin.models.warehouse.sapbwhana.SourceSystemConnection',
	Transformation = 'com.infa.odin.models.warehouse.sapbwhana.Transformation',
	TransformationRule = 'com.infa.odin.models.warehouse.sapbwhana.TransformationRule',
}

export enum SAPS4HanaClz {
	AppendView = 'com.infa.odin.models.application.saps4hana.AppendView',
	CDSView = 'com.infa.odin.models.application.saps4hana.CDSView',
	DBView = 'com.infa.odin.models.application.saps4hana.DBView',
	ExternalView = 'com.infa.odin.models.application.saps4hana.ExternalView',
	ForeignKey = 'com.infa.odin.models.application.saps4hana.ForeignKey',
	FunctionGroup = 'com.infa.odin.models.application.saps4hana.FunctionGroup',
	FunctionModule = 'com.infa.odin.models.application.saps4hana.FunctionModule',
	FunctionModuleChangingParameter = 'com.infa.odin.models.application.saps4hana.FunctionModuleChangingParameter',
	FunctionModuleExportParameter = 'com.infa.odin.models.application.saps4hana.FunctionModuleExportParameter',
	FunctionModuleImportParameter = 'com.infa.odin.models.application.saps4hana.FunctionModuleImportParameter',
	FunctionModuleTable = 'com.infa.odin.models.application.saps4hana.FunctionModuleTable',
	FunctionModuleTableField = 'com.infa.odin.models.application.saps4hana.FunctionModuleTableField',
	PrimaryKey = 'com.infa.odin.models.application.saps4hana.PrimaryKey',
	Program = 'com.infa.odin.models.application.saps4hana.Program',
	RFCConnections = 'com.infa.odin.models.application.saps4hana.RFCConnections',
	SapApplicationComponent = 'com.infa.odin.models.application.saps4hana.SapApplicationComponent',
	SapClass = 'com.infa.odin.models.application.saps4hana.SapClass',
	SapDataElement = 'com.infa.odin.models.application.saps4hana.SapDataElement',
	SapDataSource = 'com.infa.odin.models.application.saps4hana.SapDataSource',
	SapDataSourceField = 'com.infa.odin.models.application.saps4hana.SapDataSourceField',
	SapDomain = 'com.infa.odin.models.application.saps4hana.SapDomain',
	SapPackage = 'com.infa.odin.models.application.saps4hana.SapPackage',
	SapSchema = 'com.infa.odin.models.application.saps4hana.SapSchema',
	SapTable = 'com.infa.odin.models.application.saps4hana.SapTable',
	SapTableField = 'com.infa.odin.models.application.saps4hana.SapTableField',
	SapView = 'com.infa.odin.models.application.saps4hana.SapView',
	SapViewField = 'com.infa.odin.models.application.saps4hana.SapViewField',
	Tcode = 'com.infa.odin.models.application.saps4hana.Tcode',
}

export enum SSISClz {
	Calculation = 'com.infa.odin.models.SSIS.Calculation',
	Column = 'com.infa.odin.models.SSIS.Column',
	DataTask = 'com.infa.odin.models.SSIS.DataTask',
	Folder = 'com.infa.odin.models.SSIS.Folder',
	Package = 'com.infa.odin.models.SSIS.Package',
	Script = 'com.infa.odin.models.SSIS.Script',
}

export enum SSRSClz {
	DataSet = 'com.infa.odin.models.SSRS.DataSet',
	Field = 'com.infa.odin.models.SSRS.Field',
	Folder = 'com.infa.odin.models.SSRS.Folder',
	PlSqlStatement = 'com.infa.odin.models.SSRS.PlSqlStatement',
	Project = 'com.infa.odin.models.SSRS.Project',
	Report = 'com.infa.odin.models.SSRS.Report',
}

export enum SalesforceClz {
	Field = 'com.infa.odin.models.Salesforce.Field',
	ListView = 'com.infa.odin.models.Salesforce.ListView',
	ListViewColumn = 'com.infa.odin.models.Salesforce.ListViewColumn',
	Object = 'com.infa.odin.models.Salesforce.Object',
	Organization = 'com.infa.odin.models.Salesforce.Organization',
	Trigger = 'com.infa.odin.models.Salesforce.Trigger',
}

export enum SappdClz {
	Association = 'com.infa.odin.models.sappd.Association',
	BusinessRule = 'com.infa.odin.models.sappd.BusinessRule',
	Column = 'com.infa.odin.models.sappd.Column',
	Condition = 'com.infa.odin.models.sappd.Condition',
	Database = 'com.infa.odin.models.sappd.Database',
	Default = 'com.infa.odin.models.sappd.Default',
	Dimension = 'com.infa.odin.models.sappd.Dimension',
	DimensionAttribute = 'com.infa.odin.models.sappd.DimensionAttribute',
	Domain = 'com.infa.odin.models.sappd.Domain',
	ExtendedAttribute = 'com.infa.odin.models.sappd.ExtendedAttribute',
	ExtendedAttributes = 'com.infa.odin.models.sappd.ExtendedAttributes',
	Fact = 'com.infa.odin.models.sappd.Fact',
	FactAttribute = 'com.infa.odin.models.sappd.FactAttribute',
	ForeignKey = 'com.infa.odin.models.sappd.ForeignKey',
	Hierarchy = 'com.infa.odin.models.sappd.Hierarchy',
	Index = 'com.infa.odin.models.sappd.Index',
	Key = 'com.infa.odin.models.sappd.Key',
	Measure = 'com.infa.odin.models.sappd.Measure',
	MultidimensionalDiagram = 'com.infa.odin.models.sappd.MultidimensionalDiagram',
	NamedRelationEnd = 'com.infa.odin.models.sappd.NamedRelationEnd',
	Package = 'com.infa.odin.models.sappd.Package',
	PhysicalDataModel = 'com.infa.odin.models.sappd.PhysicalDataModel',
	PhysicalDiagram = 'com.infa.odin.models.sappd.PhysicalDiagram',
	PrimaryKey = 'com.infa.odin.models.sappd.PrimaryKey',
	Procedure = 'com.infa.odin.models.sappd.Procedure',
	Reference = 'com.infa.odin.models.sappd.Reference',
	Schema = 'com.infa.odin.models.sappd.Schema',
	Sequence = 'com.infa.odin.models.sappd.Sequence',
	Synonym = 'com.infa.odin.models.sappd.Synonym',
	Table = 'com.infa.odin.models.sappd.Table',
	Trigger = 'com.infa.odin.models.sappd.Trigger',
	TypeValue = 'com.infa.odin.models.sappd.TypeValue',
	UnnamedRelationEnd = 'com.infa.odin.models.sappd.UnnamedRelationEnd',
	User = 'com.infa.odin.models.sappd.User',
	View = 'com.infa.odin.models.sappd.View',
	ViewColumn = 'com.infa.odin.models.sappd.ViewColumn',
	ViewReference = 'com.infa.odin.models.sappd.ViewReference',
}

export enum ScriptClz {
	Calculation = 'com.infa.odin.models.Script.Calculation',
	Folder = 'com.infa.odin.models.Script.Folder',
	Script = 'com.infa.odin.models.Script.Script',
	Statement = 'com.infa.odin.models.Script.Statement',
}

export enum SsasMultidimensionalClz {
	Cube = 'com.infa.odin.models.SsasMultidimensional.Cube',
	CubeCalculation = 'com.infa.odin.models.SsasMultidimensional.CubeCalculation',
	CubeDimension = 'com.infa.odin.models.SsasMultidimensional.CubeDimension',
	CubeDimensionHierarchy = 'com.infa.odin.models.SsasMultidimensional.CubeDimensionHierarchy',
	CubeKpi = 'com.infa.odin.models.SsasMultidimensional.CubeKpi',
	CubeMeasureGroup = 'com.infa.odin.models.SsasMultidimensional.CubeMeasureGroup',
	CubePartition = 'com.infa.odin.models.SsasMultidimensional.CubePartition',
	CubePerspective = 'com.infa.odin.models.SsasMultidimensional.CubePerspective',
	DataSourceView = 'com.infa.odin.models.SsasMultidimensional.DataSourceView',
	DataSourceViewTable = 'com.infa.odin.models.SsasMultidimensional.DataSourceViewTable',
	Dimension = 'com.infa.odin.models.SsasMultidimensional.Dimension',
	DimensionHierarchy = 'com.infa.odin.models.SsasMultidimensional.DimensionHierarchy',
	Field = 'com.infa.odin.models.SsasMultidimensional.Field',
	Project = 'com.infa.odin.models.SsasMultidimensional.Project',
}

export enum SsasTabularClz {
	Calculation = 'com.infa.odin.models.SsasTabular.Calculation',
	KPI = 'com.infa.odin.models.SsasTabular.KPI',
	MeasureGroup = 'com.infa.odin.models.SsasTabular.MeasureGroup',
	Perspective = 'com.infa.odin.models.SsasTabular.Perspective',
	PerspectiveTable = 'com.infa.odin.models.SsasTabular.PerspectiveTable',
	Project = 'com.infa.odin.models.SsasTabular.Project',
	Table = 'com.infa.odin.models.SsasTabular.Table',
}

export enum SupplementClz {
	Certification = 'core.supplement.Certification',
	ISupplement = 'core.supplement.ISupplement',
	Rating = 'core.supplement.Rating',
	UserInteraction = 'core.supplement.UserInteraction',
}

export enum TableauClz {
	Calculation = 'com.infa.odin.models.Tableau.Calculation',
	Dashboard = 'com.infa.odin.models.Tableau.Dashboard',
	DataSource = 'com.infa.odin.models.Tableau.DataSource',
	Project = 'com.infa.odin.models.Tableau.Project',
	Server = 'com.infa.odin.models.Tableau.Server',
	Site = 'com.infa.odin.models.Tableau.Site',
	Workbook = 'com.infa.odin.models.Tableau.Workbook',
	Worksheet = 'com.infa.odin.models.Tableau.Worksheet',
}

export enum TalendClz {
	Calculation = 'com.infa.odin.models.Talend.Calculation',
	Folder = 'com.infa.odin.models.Talend.Folder',
	Job = 'com.infa.odin.models.Talend.Job',
	Project = 'com.infa.odin.models.Talend.Project',
	Subjob = 'com.infa.odin.models.Talend.Subjob',
}

export enum TicketClz {
	Issue = 'com.infa.ccgf.models.issueManagement.Issue',
}
